export default __webpack_public_path__ + "locales/uk-UA/EmptyView.json?hash=d62512d62b82b36674c4fc3d117ca9f5";